import {ChangeDetectorRef, Directive, inject, Input, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {IMenuItem} from '@models/i-menu-item';
import {AuthService} from '@services/auth.service';
import {LazyRouteLoadingService} from '@services/lazy-route-loading.service';

@Directive({selector: '[SummaryWrapperBase]'})
export abstract class SummaryWrapperBase implements OnInit, OnDestroy {
  readonly lazyRouteLoading = inject(LazyRouteLoadingService);

  protected destroy$ = new Subject<void>();

  @Input() title: string = '';
  @Input() items: IMenuItem[] = [];
  @Input() separator = true;

  // sensible default; theme-specific wrappers can override in constructor
  @Input() leftSize: string = '6';
  @Input() rightSize: string = '6';


  constructor(
    protected cdr: ChangeDetectorRef,
    protected translate: TranslateService,
    protected authService: AuthService,
  ) {
  }


  ngOnInit(): void {
    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  showMenu(item: IMenuItem) {
    if (item.isAdmin) {
      return this.authService.isAdmin();
    }
    return true
  }

  onMenuClick(url: string): void {
    this.lazyRouteLoading.onMenuItemClick(url);
  }

}
